// We don't check if variables are passed, due to this logic is placed in prebuild.js file

const apiHttpUrl = String(process.env.NX_PUBLIC_API_HTTP_URL) || '';
const staticAssetsUrl = String(process.env.NX_PUBLIC_STATIC_ASSETS_URL) || '';
const appEnv = String(process.env.NX_PUBLIC_ENV) || 'production';
const vkMainUrl = String(process.env.NX_PUBLIC_VK_MAIN_URL) || '';

const config = {
  apiHttpUrl,
  staticAssetsUrl,
  appEnv,
  vkMainUrl,
} as const;

export { config };

export type Config = typeof config;
